import { useEffect, useState, useRef } from "react";
import { DigitalMenuOnDevicesImage, DigitalmMenuScreenshotOnPhoneImage, GirlWithDigitalMenuImage } from "../../assets/images";

const IndexPage: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navRef = useRef<HTMLElement>(null);
    const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);


    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (!isMenuOpen) return;
            if (navRef.current && !navRef.current.contains(e.target as Node)) {
                closeMenu();
            }
        };

        document.addEventListener("click", handleClickOutside);
        return () => document.removeEventListener("click", handleClickOutside);
    }, [isMenuOpen]);


    const toggleMenu = () => {
        setIsMenuOpen(prev => !prev);
    };

    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    const toggleFaq = (index: number) => {
        setOpenFaqIndex(openFaqIndex === index ? null : index);
    };

    const scrollTo = (id: string) => {
        const el = document.getElementById(id);
        if (!el) return;
        el.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const NavItem = ({ id, children }: { id: string; children: React.ReactNode }) => (
        <a
            style={{ "textDecoration": "none" }}
            className="text-light"
            href={`#${id}`}
            onClick={(e) => {
                e.preventDefault();
                closeMenu();
                scrollTo(id);
            }}
        >
            {children}
        </a>
    );

    return (
        <div className="index">
            <nav className="navigation" ref={navRef} aria-label="Glavna navigacija">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="nav-wrapper">
                        <div className="div-block-19">
                            <svg className="nav-logo-icon" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                <path d="M3 6h18M3 12h18M3 18h18" />
                                <circle cx="19" cy="6" r="1" />
                                <circle cx="19" cy="12" r="1" />
                                <circle cx="19" cy="18" r="1" />
                            </svg>
                            <div className="_1-25rem">QuickMenu</div>
                        </div>
                        <div className={`div-block-20${isMenuOpen ? ' display-flex' : ''}`}>
                            <NavItem id="pocetna">Početna</NavItem>
                            <NavItem id="za-goste">Za goste</NavItem>
                            <NavItem id="za-vlasnike">Za vlasnike</NavItem>
                            <NavItem id="admin">Admin</NavItem>
                            <NavItem id="paketi">Paketi</NavItem>
                            <NavItem id="kontakt">Kontakt</NavItem>
                            <a className="button-primary-2 small in-nav" onClick={closeMenu} href="https://app.quickmenu.rs/client-menu/8335be5e-ea0e-4247-9517-7dc936274d29/online" rel="noopener noreferrer">
                                <div>Testiraj meni</div>
                            </a>
                        </div>
                        <a className="button-primary-2 small out-nav" href="https://app.quickmenu.rs/client-menu/8335be5e-ea0e-4247-9517-7dc936274d29/online" rel="noopener noreferrer">
                            <div>Testiraj meni</div>
                        </a>
                        <div
                            className={`div-block-70${isMenuOpen ? ' w--open' : ''}`}
                            role="button"
                            aria-label="Open menu"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleMenu();
                            }}
                        >
                            <svg className="nav-icon" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                                <path d="M4 6h16M4 12h16M4 18h16" fill="none" stroke="currentColor" strokeWidth="2"
                                    strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </div>
            </nav>
            <section className="hero-section" id="pocetna">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper hero-section-wrapper">
                        <div className="div-block-3">
                            <div>
                                <h1 className="heading1">Digitalni meni koji radi za vas</h1>
                            </div>
                            <div>
                                <div className="text-block-2">
                                    Moderan digitalni meni za vaš restoran ili kafić.<br/> 
                                    Gosti skeniraju QR kod, pregledaju online meni<br/>
                                     i poručuju — vi ažurirate u sekundi.
                                    {/* Moderan meni za vaš lokal. Gosti skeniraju, <br />pregledaju i poručuju — vi ažurirate u sekundi. */}
                                </div>
                            </div>
                            <div className="div-block-77">
                                <a className="button-primary-2" href="https://app.quickmenu.rs/client-menu/8335be5e-ea0e-4247-9517-7dc936274d29/online" rel="noopener noreferrer">
                                    <div>Testiraj meni (Try demo)</div>
                                </a>
                                <a className="button-primary-2 secondary" onClick={() => scrollTo("paketi")}>
                                    <div>Pogledaj ponudu (See plans)</div>
                                </a>
                            </div>
                            <div className="div-block-74">
                                <div className="small-box-div-2">
                                    <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <rect x="3" y="3" width="18" height="18" rx="2" />
                                        <path d="M7 7h3v3H7zM14 7h3v3h-3zM7 14h3v3H7zM14 14h3v3h-3z" />
                                    </svg>
                                    <div>QR / NFC / Link</div>
                                </div>
                                <div className="small-box-div-2">
                                    <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                    </svg>
                                    <div>Instant izmene</div>
                                </div>
                                <div className="small-box-div-2">
                                    <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <circle cx="9" cy="21" r="1" />
                                        <circle cx="20" cy="21" r="1" />
                                        <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
                                    </svg>
                                    <div>Poručivanje i rezervacije</div>
                                </div>
                            </div>
                        </div>
                        <div className="phone-block-div">
                            <div className="phone-div">
                                <div className="div-block-82">
                                    <img loading="lazy" src={DigitalmMenuScreenshotOnPhoneImage} alt="QuickMenu digitalni meni prikazan na iPhone telefonu sa kategorijama hrane i pića" className="image-19" />
                                </div>
                                <div className="div-block-76">
                                    <div className="gradient-bg-div phone">
                                        <div>Live preview</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="photo-section">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper photo-section-wrapper">
                        <div className="div-block-83">
                            <img sizes="100vw" src={GirlWithDigitalMenuImage} alt="Prikaz digitalnog menija na ekranu koji je skeniram preko QR koda" loading="lazy" className="image-2" />
                        </div>
                        <div className="div-block-69">
                            <div className="muted-text align-center">Jednostavan pristup meniju — bez instalacije aplikacije</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="clients-func-section" id="za-goste">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper client-func">
                        <div className="section-header">
                            <div className="section-label">
                                <div>Za goste</div>
                            </div>
                            <h2 className="heading">Kako digitalni meni poboljšava iskustvo gostiju</h2>
                            <p className="text-light">Intuitivno iskustvo od prvog skeniranja do poslednje porudžbine.</p>
                        </div>
                        <div className="client-func-list-div">
                            <div className="client-func-div">
                                <div className="client-func-div-image">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <rect x="3" y="3" width="18" height="18" rx="2" />
                                        <path d="M7 7h3v3H7zM14 7h3v3h-3zM7 14h3v3H7zM14 14h3v3h-3z" />
                                    </svg>
                                </div>
                                <h3 className="heading3">Pristup meniju</h3>
                                <div className="list-list-div">
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">QR kod, link ili NFC</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Bez instalacije aplikacije</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Instant učitavanje</div>
                                    </div>
                                </div>
                            </div>
                            <div className="client-func-div">
                                <div className="client-func-div-image">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <rect x="3" y="3" width="7" height="7" />
                                        <rect x="14" y="3" width="7" height="7" />
                                        <rect x="3" y="14" width="7" height="7" />
                                        <rect x="14" y="14" width="7" height="7" />
                                    </svg>
                                </div>
                                <h3 className="heading3">
                                    Pregled proizvoda
                                </h3>
                                <div className="list-list-div">
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Kategorije i podkategorije</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Brza navigacija</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Instant učitavanje</div>
                                    </div>
                                </div>
                            </div>
                            <div className="client-func-div">
                                <div className="client-func-div-image">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <circle cx="9" cy="21" r="1" />
                                        <circle cx="20" cy="21" r="1" />
                                        <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" />
                                    </svg>
                                </div>
                                <h3 className="heading3">Poručivanje</h3>
                                <div className="list-list-div">
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Dostava, preuzimanje, za stolom</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Napomene uz stavke</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Praćenje statusa uživo</div>
                                    </div>
                                </div>
                            </div>
                            <div className="client-func-div">
                                <div className="client-func-div-image">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10" />
                                        <path d="M12 16v-4M12 8h.01" />
                                    </svg>
                                </div>
                                <h3 className="heading3">Informacije o lokalu</h3>
                                <div className="list-list-div">
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Slike, adresa, kontakt</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Radno vreme, Wi-Fi</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Društvene mreže</div>
                                    </div>
                                </div>
                            </div>
                            <div className="client-func-div">
                                <div className="client-func-div-image">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0" />
                                    </svg>
                                </div>
                                <h3 className="heading3">Poziv konobara i račun</h3>
                                <div className="list-list-div">
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Pozovi konobara</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Zatraži račun</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Opciona poruka</div>
                                    </div>
                                </div>
                            </div>
                            <div className="client-func-div">
                                <div className="client-func-div-image">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                        <line x1="16" y1="2" x2="16" y2="6" />
                                        <line x1="8" y1="2" x2="8" y2="6" />
                                        <line x1="3" y1="10" x2="21" y2="10" />
                                    </svg>
                                </div>
                                <h3 className="heading3">Rezervacije</h3>
                                <div className="list-list-div">
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Rezerviši sto online</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Prati status rezervacije</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Jednostavno otkazivanje</div>
                                    </div>
                                </div>
                            </div>
                            <div className="client-func-div">
                                <div className="client-func-div-image">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                                        <circle cx="12" cy="7" r="4" />
                                    </svg>
                                </div>
                                <h3 className="heading3">Profil gosta</h3>
                                <div className="list-list-div">
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Sve porudžbine na jednom mestu</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Istorija rezervacija</div>
                                    </div>
                                    <div className="list-div-2">
                                        <div className="list-dot"></div>
                                        <div className="text-light">Višestruki lokali</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a className="button-primary-2 small" href="https://app.quickmenu.rs/client-menu/8335be5e-ea0e-4247-9517-7dc936274d29/online" rel="noopener noreferrer">
                            <div>Testiraj meni</div>
                        </a>
                    </div>
                </div>
            </section>
            <section className="photo-section">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper photo-section-wrapper">
                        <div className="div-block-83">
                            <img sizes="100vw" alt="Prikaz digitalnog menija na ekrenu komjutera, laptopa, tableta i mobilnog telefona" src={DigitalMenuOnDevicesImage} loading="lazy" className="image-2" />
                        </div>
                        <div className="div-block-69">
                            <div className="muted-text">Responzivan dizajn — telefon, tablet, laptop, desktop</div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="owners-func-section" id="za-vlasnike">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper owners-func">
                        <div className="section-header">
                            <div className="section-label">
                                <div>Za vlasnike</div>
                            </div>
                            <h2 className="heading">Zašto vlasnici biraju QuickMenu digitalni meni</h2>
                            <p className="text-light">Praktična rešenja za svakodnevne izazove.</p>
                        </div>
                        <div className="owners-func-list-div">
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <rect x="2" y="3" width="20" height="14" rx="2" ry="2" />
                                        <line x1="8" y1="21" x2="16" y2="21" />
                                        <line x1="12" y1="17" x2="12" y2="21" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Radi na svim uređajima</h3>
                                <div className="text-block-5">Telefon, tablet, laptop — gosti koriste šta imaju.</div>
                            </div>
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <rect x="3" y="3" width="7" height="7" />
                                        <rect x="14" y="3" width="7" height="7" />
                                        <rect x="3" y="14" width="7" height="7" />
                                        <rect x="14" y="14" width="7" height="7" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Više stilova dizajna</h3>
                                <div className="text-block-5">
                                    Različiti prikazi za kategorije, podkategorije i proizvode.<br />
                                </div>
                            </div>
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <line x1="4" y1="21" x2="4" y2="14" />
                                        <line x1="4" y1="10" x2="4" y2="3" />
                                        <line x1="12" y1="21" x2="12" y2="12" />
                                        <line x1="12" y1="8" x2="12" y2="3" />
                                        <line x1="20" y1="21" x2="20" y2="16" />
                                        <line x1="20" y1="12" x2="20" y2="3" />
                                        <line x1="1" y1="14" x2="7" y2="14" />
                                        <line x1="9" y1="8" x2="15" y2="8" />
                                        <line x1="17" y1="16" x2="23" y2="16" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Prilagodite izgled</h3>
                                <div className="text-block-5">
                                    Fontovi, boje i stilovi kartica — vaš brend, vaš meni.<br />
                                </div>
                            </div>
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <circle cx="12" cy="12" r="10" />
                                        <line x1="2" y1="12" x2="22" y2="12" />
                                        <path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Bez posebnog sajta</h3>
                                <div className="text-block-5">
                                    Sve info o lokalu je već u meniju — radno vreme, kontakt, mreže.<br />
                                </div>
                            </div>
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <polygon points="3 11 22 2 13 21 11 13 3 11" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Glatka navigacija</h3>
                                <div className="text-block-5">
                                    Brzo prebacivanje između kategorija — bez stalnog vraćanja.<br />
                                </div>
                            </div>
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Instant ažuriranje</h3>
                                <div className="text-block-5">
                                    Promenite cenu ili opis — gosti vide odmah.<br />
                                </div>
                            </div>
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <circle cx="12" cy="12" r="5" />
                                        <line x1="12" y1="1" x2="12" y2="3" />
                                        <line x1="12" y1="21" x2="12" y2="23" />
                                        <line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                                        <line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                                        <line x1="1" y1="12" x2="3" y2="12" />
                                        <line x1="21" y1="12" x2="23" y2="12" />
                                        <line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                                        <line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Dnevni / noćni meni</h3>
                                <div className="text-block-5">
                                    Aktivirajte različite menije u par klikova.<br />
                                </div>
                            </div>
                            <div className="owners-func-div">
                                <div className="gradient-bg-div owner-func-icon">
                                    <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
                                        <polyline points="17 6 23 6 23 12" />
                                    </svg>
                                </div>
                                <h3 className="heading3 _0-5rem-mb fw-600 align-center">Bolji uespesi</h3>
                                <div className="text-block-5">Tagovi i slike pomažu gostima da probaju više.</div>
                            </div>
                        </div>
                        <a className="button-primary-2 small" onClick={() => scrollTo("paketi")}>
                            <div>Pogledaj ponudu</div>
                        </a>
                    </div>
                </div>
            </section>
            <section className="section section-light" id="kako-poceti">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper owners-func">
                        <div className="section-header">
                            <div className="section-label">
                                <div>Kako početi</div>
                            </div>
                            <h2 className="heading">Četiri koraka do vašeg digitalnog menija</h2>
                            <p className="text-light">Brza aktivacija, bez komplikacija.</p>
                        </div>
                        <div className="how-to-start-list-div">
                            <div className="how-to-start-div-block">
                                <div className="gradient-bg-div how-to-start">
                                    <div>1</div>
                                    <div className="how-to-start-line-div"></div>
                                </div>
                                <div>
                                    <h3 className="heading3 _0-5rem-mb align-center">Kreirajte lokal</h3>
                                    <div className="text-light _0-875rem align-center">Dodajte logo, slike, radno vreme i linkove ka mrežama.</div>
                                </div>
                            </div>
                            <div className="how-to-start-div-block">
                                <div className="gradient-bg-div how-to-start">
                                    <div>2</div>
                                    <div className="how-to-start-line-div"></div>
                                </div>
                                <div>
                                    <h3 className="heading3 _0-5rem-mb align-center">Dodajte proizvode</h3>
                                    <div className="text-light _0-875rem align-center">Kategorije, podkategorije, stavke sa slikama i opisima.</div>
                                </div>
                            </div>
                            <div className="how-to-start-div-block">
                                <div className="gradient-bg-div how-to-start">
                                    <div>3</div>
                                    <div className="how-to-start-line-div"></div>
                                </div>
                                <div>
                                    <h3 className="heading3 _0-5rem-mb align-center">Generišite QR kod</h3>
                                    <div className="text-light _0-875rem align-center">QR, NFC tag ili direktan link — kako vam odgovara.</div>
                                </div>
                            </div>
                            <div className="how-to-start-div-block">
                                <div className="gradient-bg-div how-to-start">
                                    <div>4</div>
                                </div>
                                <div>
                                    <h3 className="heading3 _0-5rem-mb align-center">Krenite uživo</h3>
                                    <div className="text-light _0-875rem align-center">Meni je aktivan. Menjajte bilo kad — odmah je vidljivo.</div>
                                </div>
                            </div>
                        </div>
                        <div className="os-footer-div">
                            <div className="os-footer-icon-div">
                                <svg className="icon-size-24-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                    <polyline points="20 12 20 22 4 22 4 12" />
                                    <rect x="2" y="7" width="20" height="5" />
                                    <line x1="12" y1="22" x2="12" y2="7" />
                                    <path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7z" />
                                    <path d="M12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z" />
                                </svg>
                            </div>
                            <div className="div-block-68">
                                <div className="bold-1rem-2">Materijali za marketing</div>
                                <div className="text-light _0-875rem">10+ dizajn šablona za štampane stojke, 4 modela stalaka i nalepnice — sve uključeno u paket.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section" id="admin">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper admin-panel">
                        <div className="section-header">
                            <div className="section-label">
                                <div>Admin panel</div>
                            </div>
                            <h2 className="heading">Admin panel - Sve na jednom mestu</h2>
                            <p className="text-light">Jednostavan dashboard za potpunu kontrolu.</p>
                        </div>
                        <div className="div-block-81">
                            <div className="ap-list-div">
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <line x1="8" y1="6" x2="21" y2="6" />
                                            <line x1="8" y1="12" x2="21" y2="12" />
                                            <line x1="8" y1="18" x2="21" y2="18" />
                                            <line x1="3" y1="6" x2="3.01" y2="6" />
                                            <line x1="3" y1="12" x2="3.01" y2="12" />
                                            <line x1="3" y1="18" x2="3.01" y2="18" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Upravljanje menijem</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Kategorije: kreiranje, izmena, brisanje, deaktivacija</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Podkategorije: kreiranje, izmena, brisanje, deaktivacija</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Stavke: naziv, opis, tagovi, cena, slika</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9" />
                                            <path d="M13.73 21a2 2 0 01-3.46 0" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Obaveštenja</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Kreiranje i upravljanje notifikacijama za goste</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <circle cx="13.5" cy="6.5" r="0.5" fill="#8b5cf6" />
                                            <circle cx="17.5" cy="10.5" r="0.5" fill="#8b5cf6" />
                                            <circle cx="8.5" cy="7.5" r="0.5" fill="#8b5cf6" />
                                            <circle cx="6.5" cy="12.5" r="0.5" fill="#8b5cf6" />
                                            <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 011.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.555C21.965 6.012 17.461 2 12 2z" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Brending i stil</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Fontovi, boje, stilovi kartica</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Prilagođen izgled za vaš brend</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                                            <polyline points="9 22 9 12 15 12 15 22" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Profil lokala</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Naziv, opis, radno vreme</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Wi-Fi ime i lozinka</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Glavna slika, pozadine, mreže</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <rect x="3" y="3" width="7" height="7" />
                                            <rect x="14" y="3" width="7" height="7" />
                                            <rect x="3" y="14" width="7" height="7" />
                                            <rect x="14" y="14" width="3" height="3" />
                                            <rect x="18" y="14" width="3" height="3" />
                                            <rect x="14" y="18" width="3" height="3" />
                                            <rect x="18" y="18" width="3" height="3" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">QR generator</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Više veličina i boja</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Spremno za štampu</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Stavke: naziv, opis, tagovi, cena, slika</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                                            <line x1="3" y1="9" x2="21" y2="9" />
                                            <line x1="9" y1="21" x2="9" y2="9" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Stolovi i mapa</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Kreiranje i upravljanje stolovima</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">2D raspored prostora</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Stavke: naziv, opis, tagovi, cena, slika</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">
                                            Porudžbine uživo<br />
                                        </h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Praćenje dostave, preuzimanja, porudžbina za stolom</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Vizualizacija rasporeda stolova</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Ažuriranje statusa u realnom vremenu</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <path d="M23 21v-2a4 4 0 00-3-3.87" />
                                            <path d="M16 3.13a4 4 0 010 7.75" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Pozivi konobara</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Pregled poziva sa stolova</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Poruke od gostiju</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                                            <line x1="16" y1="2" x2="16" y2="6" />
                                            <line x1="8" y1="2" x2="8" y2="6" />
                                            <line x1="3" y1="10" x2="21" y2="10" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Rezervacije</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Dodela stola, promena statusa</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">2D raspored prostora</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Stavke: naziv, opis, tagovi, cena, slika</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Više lokacija</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Jedan admin — više lokala</div>
                                        </div>
                                    </div>
                                </div>
                                <div className="ap-div">
                                    <div className="ap-header-div">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                        </svg>
                                        <h3 className="heading-4 _0-875rem">Režim za osoblje</h3>
                                    </div>
                                    <div className="list-list-div">
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Konobar mod sa ograničenim pristupom</div>
                                        </div>
                                        <div className="list-div-2">
                                            <div className="list-dot light"></div>
                                            <div className="text-light">Pregled i ažuriranje porudžbina i rezervacija</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="admin-panel-html-div-block">
                                <div className="admin-panel-html-and-text-div">
                                    <div className="admin-panel-html-div">
                                        <div className="admin-panel-html-header-div">
                                            <div className="gradient-bg-div admin-panel-html-header-color"></div>
                                            <div className="admin-panel-html-header-dots-list-div">
                                                <div className="admin-panel-html-header-dot-div"></div>
                                                <div className="admin-panel-html-header-dot-div"></div>
                                                <div className="admin-panel-html-header-dot-div"></div>
                                            </div>
                                        </div>
                                        <div className="admin-panel-html-body-div">
                                            <div className="admin-panel-html-body-sidbar-div">
                                                <div className="gradient-bg-div admin-panel-html-body-sidbar-color-div"></div>
                                                <div className="admin-panel-html-body-sidbar-color-div"></div>
                                                <div className="admin-panel-html-body-sidbar-color-div"></div>
                                                <div className="admin-panel-html-body-sidbar-color-div"></div>
                                            </div>
                                            <div className="admin-panel-html-body-main-div">
                                                <div className="admin-panel-html-body-main-content-style-1"></div>
                                                <div className="admin-panel-html-body-main-content-style-2"></div>
                                                <div className="admin-panel-html-body-main-content-style-2"></div>
                                                <div className="admin-panel-html-body-main-content-style-2"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="muted-text _0-875rem _1-5rem-mt">
                                        Admin dashboard — kontrola na dohvat ruke<br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section section-light" id="paketi">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper owners-func">
                        <div className="section-header">
                            <div className="section-label">
                                <div>Paketi</div>
                            </div>
                            <h2 className="heading">Jednostavno i transparentno</h2>
                            <p className="text-light">Izaberite paket koji odgovara vašim potrebama.</p>
                        </div>
                        <div className="plan-list-div">
                            <div className="plan-div">
                                <div className="plan-header-div">
                                    <div className="_1-5rem">Basic</div>
                                    <div className="_2rem bold">Od 1.990,00</div>
                                    <div className="muted-text _0-875rem">RSD / mesečno</div>
                                </div>
                                <div className="plan-hr"></div>
                                <div className="plan-feat-list">
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Digitalni meni (QR / link / NFC)</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Kategorije, podkategorije, proizvodi</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Info stranica lokala</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Radno vreme, kontakt, Wi-Fi</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">
                                            Osnovni stilovi<br />
                                        </div>
                                    </div>
                                </div>
                                <a className="button-primary-2 secondary medium" onClick={() => scrollTo("kontakt")}>
                                    <div>Kontaktirajte nas</div>
                                </a>
                            </div>
                            <div className="plan-div popular">
                                <div className="plan-header-div">
                                    <div className="_1-5rem">Plus</div>
                                    <div className="_2rem bold">Od 2.490,00</div>
                                    <div className="muted-text _0-875rem">RSD / mesečno</div>
                                </div>
                                <div className="plan-hr"></div>
                                <div className="plan-feat-list">
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Sve iz Basic paketa</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Napredni stilovi (fontovi, boje, kartice)</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Obaveštenja za goste</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Poručivanje (dostava / preuzimanje / za stolom)</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Praćenje statusa porudžbine uživo</div>
                                    </div>
                                </div>
                                <a className="button-primary-2 medium" onClick={() => scrollTo("kontakt")}>
                                    <div>Kontaktirajte nas</div>
                                </a>
                                <div className="div-block-78">
                                    <div className="gradient-bg-div popular-plan">
                                        <div>Popularan</div>
                                    </div>
                                </div>
                            </div>
                            <div className="plan-div">
                                <div className="plan-header-div">
                                    <div className="_1-5rem">Premium</div>
                                    <div className="_2rem bold">Od 2.990,00</div>
                                    <div className="muted-text _0-875rem">RSD / mesečno</div>
                                </div>
                                <div className="plan-hr"></div>
                                <div className="plan-feat-list">
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Sve iz Plus paketa</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">
                                            Rezervacije sa dodelom stola<br />
                                        </div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Stolovi i 2D mapa prostora</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Upravljanje više lokacija</div>
                                    </div>
                                    <div className="plan-feat">
                                        <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                            <polyline points="20 6 9 17 4 12" />
                                        </svg>
                                        <div className="text-light _0-875rem">Režim za osoblje / konobare</div>
                                    </div>
                                </div>
                                <a className="button-primary-2 secondary medium" onClick={() => scrollTo("kontakt")}>
                                    <div>Kontaktirajte nas</div>
                                </a>
                            </div>
                        </div>
                        <div className="plan-hr-div"></div>
                        <div className="plan-footer-div">
                            <div className="div-block-80">
                                <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                                <div className="text-light _0-875rem">Bez dugoročnog ugovora — otkažite bilo kad</div>
                            </div>
                            <div className="div-block-80">
                                <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                                <div className="text-light _0-875rem">Lako prelazite na jači paket</div>
                            </div>
                            <div className="div-block-80">
                                <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" strokeWidth="2">
                                    <polyline points="20 6 9 17 4 12" />
                                </svg>
                                <div className="text-light _0-875rem">Posebna ponuda za veće objekte — kontaktirajte nas</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="section">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper owners-func">
                        <div className="section-header">
                            <div className="section-label">
                                <div>
                                    Često postavljana pitanja za digitalni meni
                                </div>
                            </div>
                            <h2 className="heading">FAQ</h2>
                            <p className="text-light align-center">
                                Brzi odgovori o QuickMenu digitalnom meniju — bez instalacije aplikacije, <br />
                                radi na svim uređajima, namenjeno restoranima i kafićenima,<br />digitalni meni u Srbiji
                            </p>
                        </div>
                        <div className="faq-list-div">

                            <div className="faq-div">
                                <a className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(0);
                                    }}
                                    role="button"
                                >
                                    <h3 className="heading3">Šta je QuickMenu digitalni meni?</h3>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 0 && (
                                    <div className="faq-answer">
                                        <div className="text-light">QuickMenu je digitalni meni namenjen restoranima i kafićima u Srbiji. Gosti pristupaju meniju preko QR koda, NFC taga ili direktnog linka i mogu pregledati ponudu, poručiti i rezervisati sto — bez instalacije aplikacije.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(1);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Da li gosti moraju da instaliraju aplikaciju?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 1 && (

                                    <div className="faq-answer">
                                        <div className="text-light">Ne. Meni se otvara direktno u browseru na telefonu — bez instalacije aplikacije. Dovoljno je skenirati QR kod ili otvoriti link/NFC.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(2);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Kako funkcioniše QR digitalni meni meni?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 2 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Na stolu ili ulazu postavite QR kod za digitalni meni. Gost ga skenira kamerom, meni se odmah učita i može da pregleda kategorije, proizvode, detalje i (ako je omogućeno) da poruči ili rezerviše.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(3);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Da li mogu da menjam cene i opise u realnom vremenu?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 3 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Da. Sve izmene u admin panelu su instant — nema čekanja. Promene cena, opisa i dostupnosti gosti vide odmah nakon osvežavanja/ponovnog otvaranja menija.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(4);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Koliko je proizvoda dozvoljeno?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 4 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Broj proizvoda je neograničen. Možete dodavati koliko god kategorija, podkategorija i stavki vam je potrebno.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(5);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Na kojim uređajima je QuickMenu digitalni meni dostupan?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 5 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Radi na svim uređajima: telefon, tablet, laptop i desktop. Meni je responzivan i prilagođen različitim ekranima.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(6);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Sa kojim uređajem mogu pristupiti admin delu?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 6 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Admin panelu možete pristupiti sa bilo kog uređaja — telefon, tablet, laptop ili desktop. Potreban je samo browser i pristupni podaci.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(7);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Ko kontroliše podešavanja lokala?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 7 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Podešavanja lokala kontroliše isključivo admin. Admin upravlja menijem, cenama, slikama, informacijama o lokalu, stilom/brendingom i opcijama poručivanja.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(8);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Koliko vremena treba da promene postanu vidljive gostima?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 8 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Odmah. Izmene su instant i vidljive su čim se sačuvaju u admin panelu.</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(9);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Da li postoje popusti?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 9 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Da. Prvi korisnici dobijaju 50% popusta na paket, kao i dodatne privilegije u budućnosti (rani pristup novim opcijama i prioritetna podrška).</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(10);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Da li QuickMenu radi bez posebnog sajta?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 10 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Da. Ne treba vam poseban sajt — sve informacije o lokalu mogu biti direktno u meniju (kontakt, radno vreme, Wi-Fi, društvene mreže, slike).</div>
                                    </div>
                                )}
                            </div>

                            <div className="faq-div">
                                <a
                                    className="faq-header w-inline-block"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        toggleFaq(11);
                                    }}
                                    role="button"
                                >
                                    <div className="heading3">Da li QuickMenu podržava poručivanje i rezervacije?</div>
                                    <svg className="icon-size-16-2" viewBox="0 0 24 24" fill="none" stroke="#484849" strokeWidth="2">
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                </a>
                                {openFaqIndex === 11 && (
                                    <div className="faq-answer">
                                        <div className="text-light">Da. QuickMenu podržava poručivanje (dostava, preuzimanje ili za stolom) i rezervacije, u zavisnosti od paketa i podešavanja lokala.</div>
                                    </div>
                                )}
                            </div>


                        </div>
                    </div>
                </div>
            </section>

            <section className="section" id="kontakt">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="content-wrapper admin-panel">
                        <div className="section-header">
                            <div className="section-label">
                                <div>Kontakt</div>
                            </div>
                            <h2 className="heading">Imate pitanja?</h2>
                            <p className="text-light">Odgovaramo brzo. Javite nam se.</p>
                        </div>
                        <div className="contact-list-div">
                            <div className="contact--div">
                                <div className="gradient-bg-div contact-div">
                                    <svg className="icon-size-28-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                                    </svg>
                                </div>
                                <div className="muted-text _0-875rem">Telefon</div>
                                <div className="semi-bold contact">+381 61 2188081</div>
                            </div>
                            <div className="contact--div">
                                <div className="gradient-bg-div contact-div">
                                    <svg className="icon-size-28-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                                        <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" />
                                        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                                    </svg>
                                </div>
                                <div className="muted-text _0-875rem">Instagram</div>
                                <div className="semi-bold contact">@quickmenu.rs</div>
                            </div>
                            <div className="contact--div">
                                <div className="gradient-bg-div contact-div">
                                    <svg className="icon-size-28-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                                        <polyline points="22,6 12,13 2,6" />
                                    </svg>
                                </div>
                                <div className="muted-text _0-875rem">Email</div>
                                <div className="semi-bold contact">quickmenu.rs@gmail.com</div>
                            </div>
                        </div>
                        <a className="button-primary-2" onClick={() => scrollTo("kontakt")}>
                            <div>Kontaktirajte nas (Contact us)</div>
                        </a>
                    </div>
                </div>
            </section>

            <footer className="footer-section">
                <div className="w-layout-blockcontainer container-2 w-container">
                    <div className="footer-wrapper">
                        <div className="div-block-75">
                            <div className="div-block-79">
                                <div className="div-block-72">
                                    <svg className="icon-size-20-2" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2">
                                        <path d="M3 6h18M3 12h18M3 18h18" />
                                        <circle cx="19" cy="6" r="1" />
                                        <circle cx="19" cy="12" r="1" />
                                        <circle cx="19" cy="18" r="1" />
                                    </svg>
                                    <div className="text-block-7">QuickMenu</div>
                                </div>
                                <div>Digitalni meni za moderan ugostiteljski objekat.</div>
                            </div>
                            <div className="div-block-71">
                                <div>Politika privatnosti</div>
                                <div>Uslovi korišćenja</div>
                            </div>
                        </div>
                        <div className="footer-hr"></div>
                        <div className="div-block-73">
                            <div className="text-block-43">© 2026 QuickMenu. Sva prava zadržana.</div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default IndexPage;